import React, { useEffect, useState } from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import {
  PaginatedSingleDropdown,
  SimpleFormSingleDropdown,
} from 'candidate_profile_redesign/shared/form/Fields';
import { standardRequestWithErrorFlash } from 'shared/utils/request';
import { DropdownOption } from 'candidate_profile_redesign/shared/form/Fields';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown/item';
import { recursiveMapToItems } from 'candidate_profile_redesign/shared/utils';
import AutomationIcon from '@grnhse/seedling/lib/birch/icons/automation';
// @ts-expect-error TS7016 - Could not find a declaration file for module 'legacy/routes'.
import Routes from 'legacy/routes';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('candidate_profile_redesign.modals.add_to_job');

declare global {
  interface Window {
    Routes: Record<string, string>;
  }
}

interface Stage {
  id: number;
  name: string;
  may_trigger_action: boolean;
}

interface StagesResponse {
  status: 'success' | 'error';
  stages: Array<Stage>;
}

const automationAdornment = <AutomationIcon size="sm" />;

const SelectJobStageFields = ({
  hiringPlansPath,
  showAutomationIndicator = false,
}: {
  hiringPlansPath?: string;
  showAutomationIndicator?: boolean;
}) => {
  const { setValue, watch } = useFormContext();

  const hiringPlan: Item = watch('hiring_plan');
  const [options, setOptions] = useState<DropdownOption[]>([]);

  useEffect(() => {
    const handleJobChange = async (jobId: string) => {
      let url = Routes.hiring_plan_stages_json_path_template;
      url = url.replace('{{id}}', jobId);

      const res = await standardRequestWithErrorFlash.get<StagesResponse>(url);
      const stageOptions: DropdownOption[] = res.data.stages.map(
        (stage: Stage) => ({
          label: stage.name,
          value: stage.id.toString(),
          ...(showAutomationIndicator &&
            stage.may_trigger_action && {
              startAdornment: automationAdornment,
            }),
        })
      );
      setOptions(stageOptions);
      if (stageOptions.length > 0) {
        setValue('stage', stageOptions[0]);
      }
    };
    if (hiringPlan) {
      handleJobChange(hiringPlan.value);
    } else {
      setValue('stage', null);
      setOptions([]);
    }
  }, [hiringPlan, setValue, showAutomationIndicator]);

  return (
    <Stack>
      <PaginatedSingleDropdown
        getOptionsUrl={hiringPlansPath || ''}
        name="hiring_plan"
        label={t('job_name')}
        rules={{ required: true }}
        pageSize={1}
        placeholder={t('job_name_placeholder')}
        transformValues={(res) => recursiveMapToItems(res.results)}
      />
      <SimpleFormSingleDropdown
        name="stage"
        label={t('job_stage')}
        disabled={options.length === 0}
        items={options}
        required
        clearable={false}
      />
    </Stack>
  );
};

export default SelectJobStageFields;
